import CrudCustom from '../../../libs/custom/CrudCustom';

let TipeBiayaLamp1771iis = new CrudCustom('/kategori-biaya-lamp-1771-iis');
export default TipeBiayaLamp1771iis;
